var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorEmailOtp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.786,
    height: 323.328,
    viewBox: "0 0 255.786 323.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3467",
    transform: "translate(-1034.119 -2711.728)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12522",
    d: "M559.84 383.493H331.021a13.5 13.5 0 0 0-13.484 13.484v142.461a13.5 13.5 0 0 0 13.484 13.484h228.818a13.5 13.5 0 0 0 13.484-13.484V396.977a13.5 13.5 0 0 0-13.483-13.484z",
    transform: "translate(716.582 2482.133)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12523",
    d: "M559.84 383.493H331.021a13.5 13.5 0 0 0-13.484 13.484v142.461a13.5 13.5 0 0 0 13.484 13.484h228.818a13.5 13.5 0 0 0 13.484-13.484V396.977a13.5 13.5 0 0 0-13.483-13.484zm4.425 102.332a55.432 55.432 0 0 1-54.5 55.215c-23.218.3 12.846.42-15.156.42-64.032 0-130.8-.612-155.712-1.009a12.562 12.562 0 0 1-12.3-12.511V396.987a4.44 4.44 0 0 1 4.424-4.435H559.83a4.44 4.44 0 0 1 4.434 4.423z",
    transform: "translate(716.582 2482.133)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12524",
    d: "M534.3 261.538H359.963a7.493 7.493 0 0 0-7.043 4.967l-26.925 75.54a7.478 7.478 0 0 0 7.033 9.988l233.813.415h.01a7.478 7.478 0 0 0 6.873-10.423l-.408.175.408-.175-32.553-75.955a7.469 7.469 0 0 0-6.873-4.532z",
    transform: "translate(713.956 2522.055)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12525",
    d: "M574.329 379.991a7.494 7.494 0 0 1-.605 2.946L541.173 441.4a7.5 7.5 0 0 1-6.875 4.527H359.966a7.5 7.5 0 0 1-7.049-4.964L326 382.917a7.473 7.473 0 0 1 4.534-9.552 7.356 7.356 0 0 1 2.5-.437l28.561-.054 11.657-.02 153.393-.269 11.664-.02 28.541-.054h.007a7.481 7.481 0 0 1 7.48 7.479z",
    transform: "translate(713.956 2485.729)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12526",
    d: "M360.038 542.358c3.457 0 50.93 2.9 50.93 6.358s-47.473 6.161-50.93 6.161a6.26 6.26 0 0 1 0-12.519z",
    transform: "translate(704.719 2430.131)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12527",
    d: "M540.974 193.221h-147a14.876 14.876 0 0 0-14.859 14.859v179.163h172.716a7.384 7.384 0 0 0 4-1.164v-178a14.876 14.876 0 0 0-14.859-14.859z",
    transform: "translate(696.424 2544.418)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12528",
    d: "M490.541 211.131h-80.558a13.547 13.547 0 0 0-13.534 13.527v168.448h153.393V270.433a59.37 59.37 0 0 0-59.3-59.3z",
    transform: "translate(690.751 2538.555)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12529",
    d: "M534.823 459.421H433.7a3.3 3.3 0 1 0 0 6.592h101.123a3.3 3.3 0 1 0 0-6.592z",
    transform: "translate(679.638 2457.28)",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12530",
    d: "M534.821 440.041H433.693a3.3 3.3 0 0 0 0 6.6h101.128a3.3 3.3 0 1 0 0-6.6z",
    transform: "translate(679.639 2463.624)",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12531",
    d: "M477.531 420.671h-43.837a3.3 3.3 0 0 0 0 6.592h43.837a3.3 3.3 0 1 0 0-6.592z",
    transform: "translate(679.638 2469.964)",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12532",
    d: "M534.821 380.091H433.693a3.3 3.3 0 0 0 0 6.6h101.128a3.3 3.3 0 1 0 0-6.6z",
    transform: "translate(679.639 2483.248)",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12533",
    d: "M534.823 360.721H433.7a3.3 3.3 0 1 0 0 6.592h101.123a3.3 3.3 0 0 0 0-6.592z",
    transform: "translate(679.638 2489.588)",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12534",
    d: "M477.53 341.341h-43.838a3.3 3.3 0 1 0 0 6.6h43.838a3.3 3.3 0 1 0 0-6.6z",
    transform: "translate(679.64 2495.932)",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12535",
    d: "M534.821 300.761H433.693a3.3 3.3 0 0 0 0 6.6h101.128a3.3 3.3 0 1 0 0-6.6z",
    transform: "translate(679.639 2509.216)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12536",
    d: "M534.821 281.391H433.693a3.3 3.3 0 0 0 0 6.6h101.128a3.3 3.3 0 1 0 0-6.6z",
    transform: "translate(679.639 2515.556)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12537",
    d: "M477.53 262.011h-43.838a3.3 3.3 0 0 0 0 6.6h43.838a3.3 3.3 0 1 0 0-6.6z",
    transform: "translate(679.64 2521.9)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2848",
    cx: 25.671,
    cy: 25.671,
    r: 25.671,
    transform: "translate(1221.076 2711.728)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12538",
    d: "M623.633 199.721a2.855 2.855 0 0 1-2.284-1.142l-7-9.338a2.855 2.855 0 1 1 4.569-3.426l4.582 6.109 11.768-17.651a2.856 2.856 0 0 1 4.752 3.168l-14.007 21.01a2.857 2.857 0 0 1-2.3 1.271z",
    transform: "translate(619.612 2551.037)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorEmailOtp);
export default __webpack_public_path__ + "static/media/VendorEmailOTP.1fbf4e65219884001e469a374567c7a2.svg";
export { ForwardRef as ReactComponent };